module.exports = __webpack_public_path__ + "black.42c0f3d.basis";